// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"1231282d","644":"1e843a8a","667":"03299f50"}[chunkId] + ".chunk.js";
};